import type { PctFormGroup } from '@pct-ng/form';
import { type FieldErrorOptions } from '@pct-ng/form';
import type { BackendErrorWithMessage } from '../error/http/typeguard/is-backend-error-with-message';

export function abstractDetailsFormRegisterFieldErrorsResolver(
  form: PctFormGroup,
  i18nService: FieldErrorOptions['i18nService'],
  resolveNotFoundPath: FieldErrorOptions['resolveNotFoundPath'],
): void {
  form.registerFieldErrorsResolver<BackendErrorWithMessage['errors']>({
    resolver: fieldErrors =>
      fieldErrors.map(({ field, strId }) => ({
        path: field,
        msg: strId,
      })),
    i18nService,
    resolveNotFoundPath,
  });
}
